import axios, { AxiosHeaders } from 'axios'
import type { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus'
import { useUserinfoStore } from '@/store/userinfo'

// 创建axios实例
const request: AxiosInstance = axios.create({
  baseURL: '/api', // 设置默认的baseURL
  timeout: 200000 // 请求超时时间
})

// 不需要token的请求路径列表
const noTokenPaths = [
  '/user/login',
  '/user/register',
  '/user/resetpassword',
  '/sendRMail',
  '/sendPMail'
]

// 验证token的方法
export const verifyToken = async () => {
  try {
    const token = localStorage.getItem('token')
    if (!token) return false
    
    const response = await request.get('/user/verify')
    return response.data.code === 200
  } catch (error) {
    return false
  }
}

// 请求拦截器
request.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // 检查请求路径是否需要token
    const needToken = !noTokenPaths.some(path => config.url?.includes(path))
    
    if (needToken) {
      const token = localStorage.getItem('token')
      if (!token) {
        ElMessage.error('请先登录')
        window.location.href = '/login'
        return Promise.reject('未登录')
      }
      // 将token添加到请求头
      if (!config.headers) {
        config.headers = new AxiosHeaders()
      }
      // 设置token请求头
      config.headers.set('token', token)
    }

    // 检查是否是文件上传请求
    if (config.data instanceof FormData) {
      // 确保不覆盖已设置的Content-Type
      if (!config.headers.get('Content-Type')) {
        config.headers.set('Content-Type', 'multipart/form-data')
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error) => {
    if (error.response) {
      const userStore = useUserinfoStore()
      
      switch (error.response.status) {
        case 401: {
          // token 过期或未登录
          userStore.clearUserInfo()
          localStorage.removeItem('token')
          ElMessage.error('登录已过期，请重新登录')
          window.location.href = '/login'
          break
        }
        case 429: {
          ElMessage.error('请求过于频繁，请稍后再试')
          break
        }
        default: {
          ElMessage.error(error.response.data?.msg || '请求失败')
          break
        }
      }
    } else {
      ElMessage.error('网络错误，请检查网络连接')
    }
    return Promise.reject(error)
  }
)

export default request 